const header = {
  definitions: 'TERMS AND DEFINITIONS',
  generalProvisions: 'GENERAL PROVISIONS AND PUBLIC OFFER',
  subjectAndObligations: 'SUBJECT OF THE AGREEMENT',
  legalNature: 'LEGAL NATURE OF THE CHARGING SERVICE',
  costAndPayments: 'FEES AND SETTLEMENTS',
  tariffsAndFeatures: 'TARIFFS AND FEATURES',
  stationOwnerDuties: 'RIGHTS AND OBLIGATIONS OF THE STATION OWNER',
  liability: 'RESPONSIBILITY OF THE PARTIES',
  complaints: 'COMPLAINTS AND DISPUTES',
  confidentiality: 'PRIVACY, PERSONAL DATA AND CONFIDENTIALITY',
  termAndOther: 'TERM, AMENDMENTS AND OTHER CONDITIONS',
};

const introduction = [
  'This Agreement is a public offer and accession agreement for charging station owners who connect equipment to the 220-km.com network.',
  'The parties to this Agreement are the Customer (charging station owner) and the Service supplier — individual entrepreneur Pavlov Maksym Valeriiovych (ФОП Павлов Максим Валерійович), tax ID 3181213230. In sessions at its stations the Customer is the Contractor for the driver and receives the driver’s payment to its own account. The Service supplier provides technical access to the Platform and the Bank API.',
  'Kyiv',
];

export const companyInfo = {
  name: 'ФОП Павлов Максим Валерійович',
  fullName: 'ФІЗИЧНА ОСОБА-ПІДПРИЄМЕЦЬ ПАВЛОВ МАКСИМ ВАЛЕРІЙОВИЧ',
  shortName: 'ФОП Павлов М.В.',
  edrpou: '3181213230',
  address: '02160, Україна, місто Київ, проспект Соборності, будинок 17 офіс 2-92',
  bankAccount: 'UA563220010000026004300057390',
  bankName: 'АТ «УНІВЕРСАЛ БАНК»',
  bankMfo: '322001',
  bankCode: '21133352',
  email: 'sales@220-km.com',
  phone: '+380982204411',
};

const body = [
  {
    id: 1,
    title: header.definitions,
    href: '#definitions',
    texts: [
      {
        id: '1.1',
        text: 'Customer / Charging Station Owner / Station Owner / Contractor — the person who connects a Charging Station to 220-km.com and, in the relevant charging session, organizes and/or provides the User with a Charging Service. The User pays the Contractor directly via the Bank’s acquiring service.',
      },
      {
        id: '1.2',
        text: 'Service supplier / Aggregator — individual entrepreneur Pavlov Maksym Valeriiovych (ФОП Павлов Максим Валерійович), tax ID 3181213230, address: 17 Sobornosti Avenue, office 2-92, Kyiv, 02160, Ukraine. Provides the Customer with technical access to the Admin Panel, the Bank API and session start. Is not the Charging Service Provider for the driver and does not receive the driver’s payment, except for the Platform commission.',
      },
      {
        id: '1.3',
        text: 'Platform — 220-km.com, the 220-km.com/b2b Admin Panel, the API and related monitoring, billing and session-start services.',
      },
      {
        id: '1.4',
        text: '220-km.com Bank API — a technical service integrating the Customer’s Admin Panel with the Bank for online payment and QR payment at the Charging Station.',
      },
      {
        id: '1.5',
        text: 'Bank / Payment Processor — JSC UNIVERSAL BANK (АТ «УНІВЕРСАЛ БАНК»), which provides acquiring to the Customer. The Aggregator does not accept or hold Users’ funds.',
      },
      {
        id: '1.6',
        text: 'Location Owner / Landlord — the person who is the owner, lessee, user or other legal owner of the place where the Charging Station is located. Energy Cost Bearer — the person who, in accordance with contracts, bills, meters or Commercial Terms, actually bears the costs of the electrical energy used by the Charging Station. The same person may simultaneously perform multiple roles.',
      },
      {
        id: '1.7',
        text: 'Charging Service — a comprehensive service consisting of providing technical access to the charging infrastructure and carrying out the process of charging the battery of an electric vehicle. The User receives a Charging Service, not electrical energy as a separate product.',
      },
      {
        id: '1.8',
        text: 'Charging Service Fee — a single integrated fee that the User pays for the charging service. Aggregator Fee / Platform Royalty — remuneration of the Aggregator for the use of the Platform, software, billing, payment and digital infrastructure.',
      },
      {
        id: '1.9',
        text: 'Advance (Аванс) — the overpayment by the Customer’s clients (drivers) that exceeds the cost of charging services actually provided. The Advance is recorded on the Platform and used for further settlements. After the services stop, the Advance is subject to return.',
      },
    ],
  },
  {
    id: 2,
    title: header.generalProvisions,
    href: '#generalProvisions',
    texts: [
      {
        id: '2.1',
        text: 'For Ukraine, this Agreement may be considered a public agreement within the meaning of Article 633 of the Civil Code of Ukraine, an accession agreement within the meaning of Article 634 of the Civil Code of Ukraine, and a public offer within the meaning of Article 641 of the Civil Code of Ukraine. Acceptance is connecting the Bank’s acquiring for stations connected to the Platform, receiving payments through the Platform, or continuing to use the Admin Panel after this version is published.',
      },
      {
        id: '2.2',
        text: 'The Customer confirms that they are at least 18 years old and have the right to dispose of the Charging Station and the location (or have the Location Owner’s consent).',
      },
      {
        id: '2.3',
        text: 'The terms of this Agreement are the same for all persons who join it, except where individual, local, technical or commercial terms are expressly specified in the Admin Panel, Commercial Terms, Station Profile or a separate agreement.',
      },
    ],
  },
  {
    id: 3,
    title: header.subjectAndObligations,
    href: '#subjectAndObligations',
    texts: [
      {
        id: '3.1',
        text: 'The Aggregator provides access to the Platform, Admin Panel, 220-km.com Bank API (NACE 63.11), billing, payment infrastructure, monitoring and other digital services: session start, tariff display, statistics and acquiring integration. These are technical services. The Law of Ukraine “On Payment Services” does not apply to them (clause 8 of part 1 of Article 9).',
      },
      {
        id: '3.2',
        text: 'Acquiring is provided solely by the Bank on the Bank’s terms. The Aggregator has no access to the Customer’s funds and is not a party to the “User — Bank” relationship.',
      },
      {
        id: '3.3',
        text: 'The service is provided “as is”. The Aggregator does not guarantee uninterrupted operation if a failure is caused by the Bank, the internet, the electricity grid, the Customer’s equipment, war, acts of authorities or other circumstances that may not be under the direct control of the Aggregator.',
      },
      {
        id: '3.4',
        text: 'Intellectual property in the Platform and API belongs to the Aggregator. The Customer receives only a right of use for the term of the Agreement.',
      },
    ],
  },
  {
    id: 4,
    title: header.legalNature,
    href: '#legalNature',
    texts: [
      {
        id: '4.1',
        text: 'The User pays a single integrated Charging Service Fee. The use of kWh as a technical calculation indicator does not constitute the sale, resale or supply of electricity to the User as a separate product.',
      },
      {
        id: '4.2',
        text: 'For Ukraine, the parties take into account that in accordance with Part Five of Article 58 of the Law of Ukraine “On the Electricity Market”, the activity of providing services for charging electric energy storage systems of electric vehicles using electric charging stations is the consumption of electric energy and is not the supply of electric energy within the meaning of the said Law.',
      },
      {
        id: '4.3',
        text: 'Energy Cost Compensation to the Energy Cost Bearer, and the share of the Station Owner or Location Owner, is an internal compensation between the participants of the model. It does not change the legal nature of the Charging Service provided to the User and does not constitute a sale of electricity to the User.',
      },
      {
        id: '4.4',
        text: 'The Customer independently ensures a lawful model for providing the Charging Station with electricity (own commercial metering point, supply contract, compensation to the landlord, or other legal model permitted by local law) and shall prevent wording, documents or actions that, without proper legal basis, reclassify the Charging Service as the sale of electricity to the User.',
      },
    ],
  },
  {
    id: 5,
    title: header.costAndPayments,
    href: '#costAndPayments',
    texts: [
      {
        id: '5.1',
        text: 'The Aggregator Fee / Platform Royalty is a commission on the User’s transaction amount: 5%, 7% or 9% depending on the tariff plan (section 6), unless another amount is specified in the Commercial Terms, Station Profile or a separate agreement.',
      },
      {
        id: '5.2',
        text: 'The Customer instructs the Bank, on the day of transaction reimbursement, to transfer the Aggregator Fee to the Aggregator’s account. Payment infrastructure fees of the Bank are paid separately under the Bank’s tariffs.',
      },
      {
        id: '5.3',
        text: 'The Parties may sign an act of services by the 15th day of the following month if the Customer prepares a draft act.',
      },
      {
        id: '5.4',
        text: 'The Aggregator has the right to introduce new paid services or change the cost of existing services by making changes to this Agreement and/or displaying relevant information in the Platform, invoice or Commercial Terms. The Aggregator may separately charge Users if this is displayed to the User before the start of the charging session.',
      },
    ],
  },
  {
    id: 6,
    title: header.tariffsAndFeatures,
    href: '#tariffsAndFeatures',
    texts: [
      {
        id: '6.1',
        text: 'Basic — 5% per transaction; port reservation is available for Users.',
      },
      {
        id: '6.2',
        text: 'Pro — 7% per transaction.',
      },
      {
        id: '6.3',
        text: 'Pro+ — 9% per transaction: dynamic tariff from SoC or DAM, Vyriy EMS integration, roaming.',
      },
      {
        id: '6.4',
        text: 'Plan comparison is on 220-km.com/b2b. The plan is chosen at connection or by agreement. A plan change takes effect after the Customer’s notice.',
        linkUrl: 'https://220-km.com/b2b',
        linkLabel: '220-km.com/b2b',
      },
    ],
  },
  {
    id: 7,
    title: header.stationOwnerDuties,
    href: '#stationOwnerDuties',
    texts: [
      {
        id: '7.1',
        text: 'The Customer shall ensure proper location, installation, connection, supply of current, voltage and grounding of the chargers in accordance with applicable regulations, rules and standards, as well as electricity metering. The minimum technical requirement for connecting the Charging Station to the Platform is stable support for the OCPP 1.6J protocol, unless otherwise specified in the Commercial Terms.',
      },
      {
        id: '7.2',
        text: 'The Customer is obliged to configure the chargers in the Platform, fill in the location address, tariffs, power, connectors, availability, identity of the Charging Service Provider, payment details and other necessary information. The tariff displayed to the User before the start of the charging session must match this data.',
      },
      {
        id: '7.3',
        text: 'The Contractor is independently responsible for the tax, accounting, licensing, consumer and other legal regime of its activities in the relevant jurisdiction, for safety at the location as the Charging Service Provider to the User, and for goods and services prohibited by payment systems: https://www.liqpay.ua/prohibited_goods.',
      },
      {
        id: '7.4',
        text: 'If the Customer is not the Location Owner, the Customer must secure the right to place the Charging Station and access for delivery, installation, start-up, service, repair, dismantling, relocation or reinstallation of the station.',
      },
    ],
  },
  {
    id: 8,
    title: header.liability,
    href: '#liability',
    texts: [
      {
        id: '8.1',
        text: 'The Aggregator is a digital, integrated payment, computing and information system that provides technical interaction between the participants of the model, but is not a party to the actual physical charging of the battery in terms of the operation of a specific station. The Aggregator is not a party to the “User — Customer”, “User — Bank” or “Customer — Bank” relationships and is not responsible for equipment malfunctions of the Customer’s stations if such circumstances are not under the direct control of the Aggregator.',
      },
      {
        id: '8.2',
        text: 'The Aggregator’s liability is limited to the amount of the last Aggregator Fee paid by the Customer. Damages are not reimbursed except where such a limitation is prohibited by mandatory applicable law.',
      },
      {
        id: '8.3',
        text: 'If, because of the Customer’s breach of payment-system or Bank rules, fines are imposed on the Aggregator, the Customer shall compensate them by way of recourse.',
      },
      {
        id: '8.4',
        text: 'In the event of a violation by the Contractor or Station Owner of the terms of this Agreement, unpaid Aggregator Fee, fraud, or an unsafe or faulty station, the Aggregator has the right to suspend the display of the station, restrict Users’ access, disconnect the station from the Platform or block payments until the violation is eliminated.',
      },
      {
        id: '8.5',
        text: 'If the Customer disconnects charging stations from the 220-km.com Platform software on their own, without prior written notice to the Aggregator, the Customer shall pay a fine of three times the Aggregator Fee for the month preceding the month in which the unauthorized disconnection took place.',
      },
    ],
  },
  {
    id: 9,
    title: header.complaints,
    href: '#complaints',
    texts: [
      {
        id: '9.1',
        text: 'Complaints about the service should be sent to sales@220-km.com within 48 hours with a description of the circumstances. A reply is given within 15 business days. Disputes are resolved through negotiations, claim correspondence or through the support service.',
      },
      {
        id: '9.2',
        text: 'This Agreement is subject to the law of Ukraine. If the dispute is not resolved, it is transferred to a court under the laws of Ukraine.',
      },
    ],
  },
  {
    id: 10,
    title: header.confidentiality,
    href: '#confidentiality',
    texts: [
      {
        id: '10.1',
        text: 'The Customer consents to processing of Admin Panel and station data to perform the Agreement. The processing of personal data is carried out in accordance with applicable data protection laws, including the Law of Ukraine “On Personal Data Protection”.',
      },
      {
        id: '10.2',
        text: 'The Aggregator, the Contractor, the Station Owner and the Location Owner undertake not to disclose confidential information and to use it only for the performance of the Agreement, provision of services, payment, security, support, compliance, reporting and legitimate business purposes, or as required by law or payment infrastructure.',
      },
      {
        id: '10.3',
        text: 'The Customer grants 220-km.com (the Service supplier) the right to publish B2B cooperation cases on the Platform and in materials about the cooperation without the Customer’s name, company name or other personal data. A publication that names the Customer or includes other personal data is allowed only with the Customer’s separate written consent.',
      },
    ],
  },
  {
    id: 11,
    title: header.termAndOther,
    href: '#termAndOther',
    texts: [
      {
        id: '11.1',
        text: 'The Agreement is valid from the moment of acceptance until obligations are fully performed. Either Party may terminate the Agreement by giving the other Party written notice at least 1 (one) month before the termination date. The Aggregator may terminate the Agreement without this notice period and without compensation in case of a material breach.',
      },
      {
        id: '11.2',
        text: 'The Aggregator has the right to amend this Agreement by publishing a new version on the Platform. Unless another term is specified, the amendments shall enter into force from the moment of publication. Further use of the Admin Panel or receipt of payments after the changes come into force shall be deemed acceptance of such changes.',
      },
      {
        id: '11.3',
        text: 'The Aggregator is a group-3 simplified-tax payer and is not a VAT payer.',
      },
      {
        id: '11.4',
        text: 'After the services stop, the Advance is subject to return. If the Advance is not returned after the services stop, a penalty of 22% per year accrues on the unreturned Advance.',
      },
      {
        id: '11.5',
        text: 'Details: individual entrepreneur Pavlov Maksym Valeriiovych (ФОП Павлов Максим Валерійович), tax ID 3181213230, IBAN UA563220010000026004300057390, JSC UNIVERSAL BANK (АТ «УНІВЕРСАЛ БАНК»), MFO 322001, sales@220-km.com, +380982204411.',
      },
    ],
  },
];

const structureDocument = {
  header,
  introduction,
  body,
};

export default structureDocument;
